import {
  CLIENT_SCREEN,
  CLIENT_SCREEN_ERROR,
  CLIENT_SCREEN_SUCCESS,
  GET_TIMELOGBYDATE,
  PROJECT_LISTS,
  PROJECT_LISTS_ERROR,
  PROJECT_LISTS_SUCCESS,
  STORE_TIMELOGBYDATE,
  WORK_SCREEN,
  WORK_SCREEN_ERROR,
  WORK_SCREEN_SUCCESS,
  MOVE_ID_HOURS_TIMELOG,
  ADD_MANUAL_ENTRY_TIMELOG,
  MOVE_ID_HOURS_FROMID,
  CHANGE_STATUS_TIMELOG,
  GET_ACTIVITYLOGBYDATE,
  STORE_ACTIVITYLOGBYDATE,
  FLAG_TIMELOG_INVALID,
} from "./actionType"

export const getallprojectslist = projectlist => {
  return {
    type: PROJECT_LISTS,
    payload: projectlist,
  }
}

export const getallprojectListsSuccess = projectlist => {
  return {
    type: PROJECT_LISTS_SUCCESS,
    payload: projectlist,
  }
}

export const getallprojectListsError = projectlist => {
  return {
    type: PROJECT_LISTS_ERROR,
    payload: projectlist,
  }
}
// screen work category

export const workScreen = screens => {
  return {
    type: WORK_SCREEN,
    payload: screens,
  }
}

export const workScreenSuccess = screens => {
  return {
    type: WORK_SCREEN_SUCCESS,
    payload: screens,
  }
}

export const workScreenError = screens => {
  return {
    type: WORK_SCREEN_ERROR,
    payload: screens,
  }
}

// client screen view

export const clientScreen = screens => {
  return {
    type: CLIENT_SCREEN,
    payload: screens,
  }
}

export const clientScreenSuccess = screens => {
  return {
    type: CLIENT_SCREEN_SUCCESS,
    payload: screens,
  }
}

export const clientScreenError = screens => {
  return {
    type: CLIENT_SCREEN_ERROR,
    payload: screens,
  }
}


// TimeLogByDate

export const getTimeLogByDateAction = data => {
  return {
    type: GET_TIMELOGBYDATE,
    payload: data
  }
}

export const storeTimeLogByDate = data => {
  return {
    type: STORE_TIMELOGBYDATE,
    payload: data
  }
}

export const moveIdHoursTimeLog = (data, callback) => {
  return {
    type: MOVE_ID_HOURS_TIMELOG,
    payload: data,
    callback
  }
}

export const addManualEntryTimeLog = (data, callback) => {
  return {
    type: ADD_MANUAL_ENTRY_TIMELOG,
    payload: data,
    callback
  }
}

export const changeStatusTimelog = (data, callback) => {
  return {
    type: CHANGE_STATUS_TIMELOG,
    payload: data,
    callback
  }
}
export const flagTimeLogInvalid = (data, callback) => {
  return {
    type: FLAG_TIMELOG_INVALID,
    payload: data,
    callback
  }
}

export const moveIdHoursFromID = (data, callback) => {
  return {
    type: MOVE_ID_HOURS_FROMID,
    payload: data,
    callback
  }
}

// ActivityLogByDate

export const getActivityLogByDateAction = data => {
  return {
    type: GET_ACTIVITYLOGBYDATE,
    payload: data
  }
}

export const storeActivityLogByDate = data => {
  return {
    type: STORE_ACTIVITYLOGBYDATE,
    payload: data
  }
}
